<template>
  <div>
    <h1 id="title">Inserir uma senha</h1>
    <p id="message">
      Este PIX está protegido por senha. Digite uma senha para exibir o QR Code.
    </p>

    <form @submit.prevent>
      <input
        type="password"
        id="password"
        name="password"
        placeholder="Digite sua senha"
        required
        autocomplete="off"
        maxlength="5"
        @keydown.enter="sendPassword()"
        @input="updatePassword($event.target.value)"
      />
      <div id="div-above-password">
        <img
          v-if="this.loading"
          class="img-loading"
          src="static/img/loading.gif"
        />
        <p v-if="this.pix_senha_invalida || this.error_message" class="error">
          {{ this.error_message }}
        </p>
      </div>
      <br />
      <input
        type="button"
        class="btn"
        value="Abrir QR Code"
        @click="this.sendPassword"
      />
    </form>
  </div>
</template>
<script>
export default {
  name: "PixPassword",
  props: ["callApi", "pix_senha_invalida"],
  data() {
    return {
      password: "",
      loading: false,
      error_message: "",
    };
  },
  methods: {
    updatePassword(newValue) {
      this.password = newValue;
    },
    sendPassword() {
      if (this.password.length != 5) {
        this.loading = false;
        this.error_message = "A senha deve ter 5 digitos.";
        return;
      }

      this.loading = true;
      this.error_message = "";
      this.callApi(this.password)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.error_message = "A senha digitada é inválida!";
        });
    },
  },
};
</script>
<style scoped>
#div-above-password {
  margin: 0px;
  height: 20px;
}

.img-loading {
  width: 50px;
  height: 50px;
}

.error {
  color: red;
  height: 20px;
  margin: 0px;
  padding-top: 13px;
}

#title {
  font-size: 1.3em;
  margin-bottom: 20px;
  color: #333;
}

#message {
  font-size: 12px;
}

#password {
  width: 100%;
  padding: 12px;
  margin: 0px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 1em;
}

.btn {
  background-color: #5b3088;
  color: #fff;
  border: none;
  padding: 12px 0;
  cursor: pointer;
  border-radius: 5px;
  font-size: 1em;
  width: 100%;
  transition: background-color 0.3s ease;
  margin-top: 5px;
}

.btn:hover {
  background-color: #4f2670;
}

.btn:focus {
  background-color: #6534a0;
}
</style>



// WEBPACK FOOTER //
// src/views/components/pix/PixPassword.vue